module.exports = __webpack_public_path__ + "img/pic_3@2x.af6b6561.png";